/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Window_Resize_TopInputs */

const en_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize from top edge`)
};

const ar_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم من الحافة العلوية`)
};

const bn_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উপরের কিনারা থেকে রিসাইজ করুন`)
};

const de_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe vom oberen Rand ändern`)
};

const es_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tamaño desde el borde superior`)
};

const fr_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner à partir du bord supérieur`)
};

const pt_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar a partir da borda superior`)
};

const zh_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从顶部边缘调整大小`)
};

const tr_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üst kenardan yeniden boyutlandır`)
};

const ru_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера от верхнего края`)
};

const pl_window_resize_top = /** @type {(inputs: Window_Resize_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień rozmiar od górnej krawędzi`)
};

/**
* | output |
* | --- |
* | "Resize from top edge" |
*
* @param {Window_Resize_TopInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const window_resize_top = /** @type {((inputs?: Window_Resize_TopInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Window_Resize_TopInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_window_resize_top(inputs)
	if (locale === "bn") return bn_window_resize_top(inputs)
	if (locale === "de") return de_window_resize_top(inputs)
	if (locale === "es") return es_window_resize_top(inputs)
	if (locale === "fr") return fr_window_resize_top(inputs)
	if (locale === "pt") return pt_window_resize_top(inputs)
	if (locale === "zh") return zh_window_resize_top(inputs)
	if (locale === "tr") return tr_window_resize_top(inputs)
	if (locale === "ru") return ru_window_resize_top(inputs)
	if (locale === "pl") return pl_window_resize_top(inputs)
	return en_window_resize_top(inputs)
});